export const toAbsoluteUrl = (pathname: string, baseUrl: string = '/') => {
  return baseUrl + pathname;
};
